import type { Change } from 'diff';

/**
 * Just trim final newline and split by newlines ignoring changes from \r\n to \n etc.
 *
 * Such edge cases (only expected to realistically appear is adding or removing trailing
 * newline at the end of a file) appear as the same line removed and added.
 */
export const getLinesFromChange = (change: Change): string[] =>
  change.value.trimEnd().split('\n');
